
<div class="join-box">
	<h4 *ngIf="teamSelectionMode == false" class="subtitle no-mb">Join with Code</h4>
	<p *ngIf="teamSelectionMode == false" for="code" class="text-muted center-text">Ask your Quizmaster for a game code.</p>
	<div *ngIf="!targetGame && teamSelectionMode == false" class="center">
		<input type="text" placeholder="XXXXXX" mask="000000" id="code" [(ngModel)]="code">
	</div>

	<p *ngIf="err" class="error-message">{{err}}</p>

	<button *ngIf="!targetGame" class="join" [disabled]="!code" (click)="findGame()">{{ loading ? 'Finding
		Game...':'Next' }}</button>

</div>

	


<!-- <div *ngIf="!hideOverlay" class="overlay">
	<h1>Hello Stranger!</h1>
	<h3>Don't forget to log in so that you can save your team, invite your friends, and keep track of your scores!</h3>
	<div>
		<button (click)=toAuth()>Login / Register</button>
	</div>
	<p class="sim-link" (click)="guest()">Continue as Guest</p>
	<p class="bottom-link">King Trivia <a class="a-buffer" href="https://kingtrivia.com/king-trivia-privacy-policy/"
			target="_blank">Privacy Policy</a> and <a class="a-buffer"
			href="https://kingtrivia.com/king-trivia-website-terms-of-use/" target="_blank">Terms of Use</a></p>
</div> -->
